import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import withPermissions from "../../components/WithPermissions";
import PageHeader from "../../components/PageHeader";
import mainHelper, {
    apiCall,
} from "../../helpers/MainHelper";
import ReactLoading from "react-loading";
class CategoryAdd extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            formData: {
                name: '',
                type: '',
            },
            loading: false,
        }
    }
    handleChange = (e) => {
        const { id, value } = e.target;
        this.setState(prevState => ({
            formData: {
                ...prevState.formData,
                [id]: value
            }
        }))
    }
    handleSubmit = async (e) => {
        e.preventDefault();
        this.setState({ loading: true });
        const { formData } = this.state;

        try {
            const response = await apiCall('business/income-expense-categories/add', 'post', formData);
            this.setState({ loading: false });
            mainHelper.toastMessage(response.status, response.message)
        } catch (e) {
            this.setState({ loading: false });
        }
    }

    render() {
        const { loading } = this.state;
        const { userPermissions } = this.props;
        const userHasNewExpenseIncomeCategoryPermission = userPermissions.includes('new expense income category');
        return (
            <div
                style={{ flex: 1 }}
                onClick={() => {
                    document.body.classList.remove("offcanvas-active");
                }}>
                <div>
                    <div className="container-fluid">
                        <PageHeader
                            HeaderText="Yeni Kategori ekle"
                            Breadcrumb={[
                                { name: "Gelir ve Giderler", navigate: "" },
                                { name: "Kategoriler", navigate: "income-expense-categories" },
                                { name: "Yeni Kategori", navigate: "" },
                            ]}
                        />
                        <div className="row clearfix">

                            <div className="card">
                                <form onSubmit={this.handleSubmit}>
                                    <div className="body">
                                        <div className="row clearfix justify-content-center">
                                            <div className="col-lg-6 col-md-12">
                                                <div className="form-group">
                                                    <small>Gelir ve gider kategorileri  ile işlemleri kategorilere ayırarak gelir ve giderlerinizi daha verimli yönetebilirsiniz. Bu sayede işletmenizin finansal durumunu net bir şekilde gözlemleyebilirsiniz.</small>
                                                </div>
                                                <div className="form-group">
                                                    <input
                                                        id="name"
                                                        className="form-control"
                                                        placeholder="Kategori adı"
                                                        type="text"
                                                        onChange={this.handleChange}
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <select id='type'
                                                        className="form-control"
                                                        onChange={this.handleChange}>
                                                        <option value="">Tip Seçiniz</option>
                                                        <option value="Gelir">Gelir</option>
                                                        <option value="Gider">Gider</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="body">
                                        <div className="row clearfix justify-content-center">
                                            <div className="col-lg-6 col-md-12">
                                                {loading ? (
                                                    <button className="btn btn-outline-primary btn-block"
                                                        disabled={true}
                                                        style={{ textAlign: "-webkit-center" }}>
                                                        Lütfen Bekleyin...<ReactLoading type="spin" width={'24px'}
                                                            height={'24px'}
                                                            color="#268bd2"></ReactLoading>
                                                    </button>
                                                ) :
                                                    <button disabled={!userHasNewExpenseIncomeCategoryPermission}
                                                        className="btn btn-outline-primary btn-block"
                                                        type="submit">
                                                        Kaydet
                                                    </button>}

                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({ ioTReducer }) => ({
    isSecuritySystem: ioTReducer.isSecuritySystem,
});

export default withPermissions(withRouter(connect(mapStateToProps, {})(CategoryAdd)));
